import { render, staticRenderFns } from "./Monthly.vue?vue&type=template&id=6060f1dd&scoped=true&lang=pug"
import script from "./Monthly.vue?vue&type=script&lang=js"
export * from "./Monthly.vue?vue&type=script&lang=js"
import style0 from "./Monthly.vue?vue&type=style&index=0&id=6060f1dd&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6060f1dd",
  null
  
)

export default component.exports